<template>
  <v-container class="pt-10">

    <v-card class="mx-auto mt-10 pt-5 text-center"
            style="max-width:500px">
      
      <v-card-text>
        
        <p>
          <alert-circle-icon size="3x" class="mr-2 error--text"/>
        </p>
        <p class="text-h4">Si è verificato un errore.</p>
        <p class="text-h5">Ti invitiamo a tornare indietro e se il problema persiste contattaci.</p>

        <v-row class="py-5">
          <v-col>
            <v-btn depressed large
                   @click="goTo('home')">
              <arrow-left-icon size="1.5x" class="mr-3"/>
              Indietro
            </v-btn>
          </v-col>
        </v-row>

      </v-card-text>

    </v-card>

  </v-container>
</template>

<script>
import utility from '@/mixins/utility'

import { AlertCircleIcon, ArrowLeftIcon } from 'vue-feather-icons'

export default {
  
  name: 'ErrorPage',

  mixins: [ utility ],

  components:
  {
    AlertCircleIcon,
    ArrowLeftIcon
  },

  data: () => ({
    
  }),

  computed:
  {
    
  },

  methods: 
  {
    
  },

  mounted()
  {
    this.setBack(false)
  },

  watch:
  {
    
  }

}
</script>
